module.exports = __webpack_public_path__ + "img/katarina_bedrooms_9.ffc1759b.jpg";